import type { Signal, SignalFilters } from "app/pages/sales-intelligence/domain/signals/types/signal";

import type UISignal from "../UISignal";

/**
 * Type guard narrowing a {@link Signal} to a {@link UISignal}.
 *
 * A plain signal carries only persistence fields (id, filters, ...), while a UISignal
 * also holds the display metadata (`name`, `nameSegments`) needed to render it. Use this
 * when a value may be either shape — e.g. a signal hydrated onto a rule vs. a bare DTO.
 *
 * @example
 * ```typescript
 * if (isUISignal(signal)) {
 *   renderChip(signal.name);
 * }
 * ```
 */
function isUISignal<Filters extends SignalFilters = SignalFilters>(
    signal: Signal<Filters>,
): signal is UISignal<Filters> {
    return "name" in signal && "nameSegments" in signal;
}

export default isUISignal;
